"use client";

import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/store/authStore";
import { useUIStore } from "@/store/uiStore";
import { Fish, Menu } from "lucide-react";
import Link from "next/link";

export function MobileHeader() {
   const toggleMobileSidebar = useUIStore((state) => state.toggleMobileSidebar);
   const admin = useAuthStore((state) => state.admin);

   return (
      <header className="sticky top-0 z-30 flex h-16 w-full items-center justify-between border-b border-[hsl(var(--border))] bg-[hsl(var(--card)/0.85)] px-4 backdrop-blur-md lg:hidden">
         <div className="flex items-center gap-3">
            <Button
               variant="ghost"
               size="icon"
               onClick={toggleMobileSidebar}
               aria-label="Открыть меню"
               className="h-10 w-10 text-[hsl(var(--foreground))] hover:bg-[hsl(var(--accent)/0.1)]"
            >
               <Menu size={22} />
            </Button>

            <Link href="/" className="flex items-center gap-2.5">
               <div className="flex h-9 w-9 items-center justify-center rounded-xl gradient-primary shadow-md">
                  <Fish size={18} className="text-white" />
               </div>
               <div>
                  <h1 className="text-base font-bold leading-none text-gradient">
                     Topfish
                  </h1>
                  <p className="text-[10px] text-[hsl(var(--muted-foreground))]">
                     Админ-панель
                  </p>
               </div>
            </Link>
         </div>

         {admin && (
            <div className="flex items-center gap-2 rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--muted)/0.4)] px-3 py-1 text-xs font-medium text-[hsl(var(--muted-foreground))]">
               <span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
               <span className="max-w-[120px] truncate text-[hsl(var(--foreground))]">
                  {admin.username}
               </span>
            </div>
         )}
      </header>
   );
}
